import { productFacetAllowedList, storeKeyMapper } from '@shared/utils';
import type { Store } from '@shared/utils/src/ct/index';

export const createFacetAttributeNames = (locale = ''): string[] => [
  ...productFacetAllowedList([storeKeyMapper(locale) as Store]),
];
